<template>
  <template v-if="confirm_data != false">
    <div class="fixed top-0 left-0 w-screen h-screen bg-g0/80 flex justify-center items-center p-10 z-[99999999999]">
      <div
        class="bg-g1 flex flex-col h-full justify-around max-w-[720px] p-5 rounded-lg shadow-[0_0_20px_10px_#2b2b2b] w-full">
        <h1 class="border-b border-g2 mb-6 pb-2">Checklist :</h1>

        <div class="w-full text-lg text-center overflow-x-auto h-full flex flex-col">
          <div v-if="Number.isInteger(device.config.flight.id)" class="animate-pulse bg-error bg-red-600 mb-4 p-2">
            ATTENTION UN VOL EST EN COURS
          </div>
          <table class="table-auto w-full cheaklist">
            <!-- Dock RC -->
            <tbody>
              <tr>
                <td colspan="3">
                  <h2 class="font-black">
                    <template v-if="device?.config?.dock?.id"> Dock : </template>
                    <template v-else-if="device?.config?.rcplus?.id">
                      RC Plus :
                    </template>
                  </h2>
                </td>
              </tr>
              <tr>
                <DockRC_Status :config="device.config" :cheack="cheack" />
              </tr>
              <tr>
                <DockRC_LastStatus :config="device.config" :cheack="cheack" />
              </tr>
              <tr>
                <HMS :config="device.config" :cheack="cheack" />
              </tr>

              <!-- Drone -->
              <tr>
                <td colspan="3">
                  <h2 class="font-black">Drone :</h2>
                </td>
              </tr>
              <tr>
                <DroneStatus :config="device.config" :cheack="cheack" />
              </tr>
              <tr>
                <DroneLastStatus :config="device.config" :cheack="cheack" />
              </tr>
              <tr>
                <DroneBatt :config="device.config" :cheack="cheack" />
              </tr>
              <tr>
                <DroneInDock :config="device.config" :cheack="cheack" />
              </tr>
              <tr>
                <DroneHeightMax :config="device.config" :cheack="cheack" />
              </tr>
              <!-- Meteo -->
              <tr>
                <td colspan="3">
                  <h2 class="font-black">Météo :</h2>
                </td>
              </tr>
              <MixedInfoMeteo :config="device.config" :cheack="cheack" />
            </tbody>
          </table>
        </div>

        <div class="flex flex-col">
          <div class="mt-5">
            <p class="text-center text-lg">Valider le lancement du vol ?</p>
          </div>
          <div class="flex mt-8 mb-8 justify-evenly flex-wrap">
            <span @click="confirm_data.resolve(false)"
              class="bg-error rounded-full w-[50px] h-[50px] mt-1 sm:mt-0 p-3 flex justify-center items-center sm:mr-1 cursor-pointer hover:opacity-80">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.717 31.717">
                <g transform="translate(-52 -31.8)">
                  <g transform="translate(38.2 18)">
                    <path
                      d="M40.156,13.8l-10.5,10.5-10.5-10.5L13.8,19.161l10.5,10.5-10.5,10.5,5.361,5.361,10.5-10.5,10.5,10.5,5.361-5.361-10.5-10.5,10.5-10.5Z"
                      transform="translate(0 0)" fill="#fff" />
                  </g>
                </g>
              </svg>
            </span>

            <span v-if="!Number.isInteger(device.config.flight.id)" @click="confirm_data.resolve(true)"
              class="bg-success rounded-full w-[50px] h-[50px] mt-1 sm:mt-0 p-2 flex justify-center items-center sm:ml-1 cursor-pointer hover:opacity-80">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37.403 29.278">
                <g transform="translate(-172.798 -99.861)">
                  <g transform="translate(139.798 37.861)">
                    <path d="M70.4,67.183l-24.1,24.1L33,77.97l5.183-5.183,8.125,8.125L65.22,62Z" fill="#fff" />
                  </g>
                </g>
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
  </template>
</template>
<script>
import { ref } from "vue";
import { bindKey, unbindKey } from "@rwh/keystrokes";

import DockRC_Status from "@/partials/Device/Template/Cheacklist/DockRC_Status.vue";
import DockRC_LastStatus from "@/partials/Device/Template/Cheacklist/DockRC_LastStatus.vue";
import HMS from "@/partials/Device/Template/Cheacklist/HMS.vue";
//-------------------------------------
import DroneStatus from "@/partials/Device/Template/Cheacklist/DroneStatus.vue";
import DroneBatt from "@/partials/Device/Template/Cheacklist/DroneBatt.vue";
import DroneLastStatus from "@/partials/Device/Template/Cheacklist/DroneLastStatus.vue";
import DroneInDock from "@/partials/Device/Template/Cheacklist/DroneInDock.vue";
import DroneHeightMax from "@/partials/Device/Template/Cheacklist/DroneHeightMax.vue";
//-------------------------------------
import MixedInfoMeteo from "@/partials/Device/Template/Cheacklist/MixedInfoMeteo.vue";

export default {
  name: "Device_Cheacklist",
  components: {
    DockRC_Status,
    DockRC_LastStatus,
    HMS,
    //-------------------------------------
    DroneStatus,
    DroneBatt,
    DroneLastStatus,
    DroneInDock,
    DroneHeightMax,
    //-------------------------------------
    MixedInfoMeteo,
  },
  setup() {
    return {
      confirm_data: ref(false),
      device: ref(false),

      cheack: {
        ok: `<span class="bg-success rounded-full w-[20px] h-[20px] p-1 flex justify-center items-center">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37.403 29.278">
            <g transform="translate(-172.798 -99.861)">
              <g transform="translate(139.798 37.861)">
                <path d="M70.4,67.183l-24.1,24.1L33,77.97l5.183-5.183,8.125,8.125L65.22,62Z" fill="#fff" />
              </g>
            </g>
          </svg>
        </span>`,
        nok: `<span class="bg-error rounded-full w-[20px] h-[20px] p-1 flex justify-center items-center">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.717 31.717">
            <g transform="translate(-52 -31.8)">
              <g transform="translate(38.2 18)">
                <path
                  d="M40.156,13.8l-10.5,10.5-10.5-10.5L13.8,19.161l10.5,10.5-10.5,10.5,5.361,5.361,10.5-10.5,10.5,10.5,5.361-5.361-10.5-10.5,10.5-10.5Z"
                  transform="translate(0 0)" fill="#fff" />
              </g>
            </g>
          </svg>
        </span>`,
        warning: `<span class="bg-warning rounded-full w-[20px] h-[20px] p-1 flex justify-center items-center">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.717 31.717">
            <g transform="translate(-52 -31.8)">
              <g transform="translate(38.2 18)">
                <path
                  d="M40.156,13.8l-10.5,10.5-10.5-10.5L13.8,19.161l10.5,10.5-10.5,10.5,5.361,5.361,10.5-10.5,10.5,10.5,5.361-5.361-10.5-10.5,10.5-10.5Z"
                  transform="translate(0 0)" fill="#fff" />
              </g>
            </g>
          </svg>
        </span>`,
      },
    };
  },

  mounted() {
    this.$root.global.startCheacklist = this.startCheacklist;
  },

  methods: {
    startCheacklist(object) {
      if (object.dev_id == undefined) {
        console.error("dev_id is not defined");
        return;
      }

      if ($root?.devices?.online[object.dev_id] != undefined) {
        this.device = $root.devices.online[object.dev_id];
      } else {
        console.error("Device not found");
        return;
      }

      this.confirm_data = object;

      this.confirm_data.promise = new Promise((resolve, reject) => {
        this.confirm_data.resolve = resolve;
      });

      this.confirm_data.promise.then((value) => {
        if (value) {
          this.confirm_data.true();
        } else {
          this.confirm_data.false();
        }

        // END RESOLVE
        this.confirm_data = false;
        unbindKey("Enter");
        unbindKey("Backspace");
        unbindKey("Delete");
        // END RESOLVE
      });

      bindKey("Enter", () => {
        this.confirm_data.resolve(true);
      });
      bindKey("Backspace", () => {
        this.confirm_data.resolve(false);
      });
      bindKey("Delete", () => {
        this.confirm_data.resolve(false);
      });
    },
  },
};
</script>
